import React from 'react';

export const FunctionalGroupWordsContext = React.createContext({
  selectedVariant: { BrickID: '', Group: '', Variant: '', Detail: '' },
  setSelectedVariant: (variant) => { }
});